import { User } from './user.model';

export interface AssignmentGroup {
  assignmentGroupId?: string;
  assignmentGroupName: string;
  users: User[];
  userCount: number;
  usersLoaded: boolean;
}
